const contentData = [
  {
    title: "Upload",
    link: "/upload/1",
    description:
      "Upload your information and choose how you want to be kustom fit"
  },
  {
    title: "Shop Securely",
    link: "/upload/2",
    description:
      "Shop with KuzFit approved merchants without sharing your data"
  },
  {
    title: "Tailored for you",
    link: "/upload/3",
    description:
      "When browsing you see products tailored to your KuzFit choices"
  }
];

export default contentData;
